import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import React from 'react';
export interface SwitchProps {
  checked?: boolean | undefined;
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined;
  className?: string;
  sliderClassName?: string;
  disabled?: boolean;
  tooltip?: boolean;
  tooltipText?: string;
  type?: string;
}

export const Switch = ({
  checked,
  onChange,
  className,
  sliderClassName,
  disabled,
  tooltip,
  tooltipText,
  type,
}: SwitchProps) => {
  const wrapperClassNames = classNames({
    'fn-switch': true,
    [className || '']: !!className,
  });
  const sliderClassNames = classNames({
    'fn-switch-slider': true,
    'fn-switch-slider-dashboard': type === 'dashboard',
    [sliderClassName || '']: !!sliderClassName,
  });
  return (
    <>
      {tooltip ? (
        <Tippy
          className="w-auto h-auto bg-gray-999 tippy"
          content={tooltipText}
          placement="top"
          arrow={false}
        >
          <label className={wrapperClassNames} aria-label="switch component">
            <input
              disabled={disabled}
              type="checkbox"
              checked={checked}
              onChange={onChange}
              aria-label="switch component"
            />
            <span className={sliderClassNames} />
          </label>
        </Tippy>
      ) : (
        <label className={wrapperClassNames} aria-label="switch component">
          <input
            disabled={disabled}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            aria-label="switch component"
          />
          <span className={sliderClassNames} />
        </label>
      )}
    </>
  );
};
